import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { parseGraphqlResult } from 'shared/domains/apollo/parseGraphqlResult';
import { UpdateContactDocument } from './UpdateContact.gql';
import { ContactLibraryListDocument } from '../ContactLibraryList.gql';
import { rejectionMessage } from '../rejectionMessage';
export function useUpdateContact(options) {
    const [rejections, setRejections] = useState([]);
    const [mutate, status] = useMutation(UpdateContactDocument, {
        onError: () => {
            setRejections(['UNKNOWN']);
            options.onError();
        },
    });
    const { loading } = status;
    const updateContact = (id, values) => {
        const { firstName, lastName, email, mobile, title, label, authenticationMode } = values;
        return mutate({
            variables: {
                id,
                input: {
                    firstName,
                    lastName,
                    email,
                    title,
                    mobile,
                    label,
                    authenticationMode,
                },
            },
            refetchQueries: [ContactLibraryListDocument],
            update(cache, result) {
                var _a;
                const [updated, rejected] = parseGraphqlResult((_a = result.data) === null || _a === void 0 ? void 0 : _a.updateEsigningRecipientValue, 'UpdateEsigningRecipientValuePayload', 'UpdateEsigningRecipientValueRejectionList');
                if (rejected) {
                    setRejections(rejected.rejections.map((rejection) => rejectionMessage(rejection.reason)));
                    options.onError();
                }
                if (updated) {
                    cache.modify({
                        id: cache.identify({
                            __typename: 'EsigningRecipientValue',
                            id,
                        }),
                        fields: {
                            name: () => `${firstName} ${lastName}`,
                            firstName: () => firstName,
                            lastName: () => lastName,
                            email: () => email,
                            mobile: () => mobile,
                            label: () => label,
                            title: () => title,
                            authenticationMode: () => authenticationMode,
                        },
                    });
                    options.onCompleted();
                }
            },
        });
    };
    return {
        updateContact,
        rejections,
        loading,
    };
}
